var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMistral = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.464 1.09h4.366v4.367h-4.366z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7D046",
  d: "M19.647 1.09h4.366v4.367h-4.366z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.09h4.366v4.367H0zm0 4.367h4.366v4.366H0zm0 4.366h4.366v4.366H0zm0 4.366h4.366v4.366H0zm0 4.366h4.366v4.366H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7D046",
  d: "M2.183 1.09h4.366v4.367H2.183z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2A73B",
  d: "M19.647 5.457h4.366v4.366h-4.366zm-17.464 0h4.366v4.366H2.183z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.098 5.457h4.366v4.366h-4.366z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2A73B",
  d: "M15.281 5.457h4.366v4.366H15.28zm-8.732 0h4.366v4.366H6.549z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE792F",
  d: "M10.915 9.823h4.366v4.366h-4.366zm4.366 0h4.366v4.366H15.28zm-8.732 0h4.366v4.366H6.549z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.732 14.189h4.366v4.366H8.732z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB5829",
  d: "M10.915 14.189h4.366v4.366h-4.366z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE792F",
  d: "M19.647 9.823h4.366v4.366h-4.366zm-17.464 0h4.366v4.366H2.183z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.464 14.189h4.366v4.366h-4.366z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB5829",
  d: "M19.647 14.189h4.366v4.366h-4.366z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M17.464 18.555h4.366v4.366h-4.366z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB5829",
  d: "M2.183 14.189h4.366v4.366H2.183z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA3326",
  d: "M19.647 18.555h4.366v4.366h-4.366zm-17.464 0h4.366v4.366H2.183z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMistral);
export default ForwardRef;